module.exports = __webpack_public_path__ + "img/safe1.4c20fc89.png";